import { persianNumbers } from 'Shared/Core/Common/Constants/persianAlphabets';
import moment from 'jalali-moment';

export function toPersianDigits(text: any): string {
  const id = persianNumbers;

  return text.replace(/[0-9]/g, function (w: any) {
    return id[+w];
  });
}

export function mobileSeprator(text: any): string {
  return `${text.substring(0, 4) + '-' + text.substring(4, 7)}`;
}

export function phoneSeprator(text: any): string {
  return `${text.substring(0, 3) + '-' + text.substring(3, 8)}`;
}

export const convertToEnglishDigits = (s: string): string => {
  // Define the arrays of Persian and Arabic digits
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

  // Replace each Persian or Arabic digit with its English equivalent
  return s
    ?.replace(/[۰-۹]/g, (d) => persianDigits.indexOf(d).toString())
    ?.replace(/[٠-٩]/g, (d) => arabicDigits.indexOf(d).toString());
};

export function convertObjectNumbers(obj: any): any {
  if (typeof obj !== 'object' || obj === null) return obj;

  if (obj instanceof Date) {
    return obj; // Return the Date object as is
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertObjectNumbers(item));
  }

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (typeof value === 'string') {
        return [key, convertToEnglishDigits(value)];
      } else if (typeof value === 'object' && value !== null) {
        return [key, convertObjectNumbers(value)];
      }
      return [key, value];
    })
  );
}

export const convertToPersianDigits = (s: string): string => {
  // Define the arrays of Persian and Arabic digits
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

  // Replace each English digit with its Persian equivalent
  return s?.replace(/[0-9]/g, (d) => persianDigits[Number(d)]?.toString());
};

export const keepOnlyDigits = (s: string): string => {
  return s?.replace(/[^\d۰-۹٠-٩]/g, '');
};

const prePhoneNumbers = [
  '041',
  '044',
  '031',
  '026',
  '045',
  '084',
  '077',
  '021',
  '038',
  '056',
  '051',
  '058',
  '061',
  '024',
  '023',
  '054',
  '071',
  '028',
  '025',
  '087',
  '034',
  '083',
  '074',
  '017',
  '013',
  '066',
  '011',
  '086',
  '076',
  '081',
  '035',
];
export function phoneValidator(text: any): boolean {
  let isValid = false;
  text = convertToEnglishDigits(keepOnlyDigits(text ?? '') ?? '');
  for (const prePhoneNumber of prePhoneNumbers) {
    isValid = text?.startsWith(prePhoneNumber);

    if (isValid === true && text?.length === 11) break;
  }
  return isValid;
}

export function phoneNumberValidator(text: any): boolean {
  const fixedText = convertToEnglishDigits(keepOnlyDigits(text ?? '') ?? '');
  return fixedText?.startsWith('09') && fixedText?.length === 11;
}

export function codeMelliValidator(codeMelli: string | undefined | null): boolean {
  return codeMelli !== undefined && codeMelli != null && keepOnlyDigits(codeMelli ?? '')?.length === 10;
}

export function codePostiValidator(codePosti: string | undefined | null): boolean {
  return codePosti !== undefined && codePosti != null && keepOnlyDigits(codePosti ?? '')?.length === 10;
}

export function removeNonDigitCharacters(text: any): string {
  return text?.replace(/\D/g, '');
}

export function thousandSeprator(text: any): string {
  return text?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function toMoney(text: any): string {
  if (Number(text)) {
    return Number(text) < 0
      ? thousandSeprator((Number(text) * -1).toString()) + '-'
      : thousandSeprator(Number(text).toString());
  } else return text.toString();
}

export function emailValidator(text: any): boolean {
  const emailRegex = /^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+@[A-Za-z0-9.-]+\.[a-zA-Z]+$/;
  return text && emailRegex.test(text?.toString());
}

export function latinValidator(text: any): boolean {
  const latinTextRegex = /^[A-Za-z\s]+$/;
  return text && latinTextRegex.test(text.toString());
}

export const PersianValidator = function (text: any): boolean {
  const persianTextRegex = /^[\u0600-\u06FF\s]+$/;
  return text && persianTextRegex.test(text.toString());
};

export const gregorianDate = function (mydate: string | Date, format: string | undefined): string {
  if (!format) format = 'DD/MM/YYYY';
  if (mydate?.toString()) return moment.from(mydate.toString(), 'fa', 'YYYY/MM/DD').locale('en').format(format);

  return '';
};

export const gregorianDateTime = function (
  val: string | Date | null | undefined,
  format?: string | undefined
): string | null {
  if (!val || val === null || val === undefined) return null;

  if (!format) format = 'YYYY-MM-DDT15:00:00';

  return moment(val).format(format);
};

export const extractNumbers = function (input: string | number): number {
  if (typeof input === 'number') return input;
  const numbersOnly = input?.replace(/\D/g, '');
  return Number(numbersOnly);
};

export {};
